export const authConstants = {
  termsLink: {
    1: 'https://mensajerosurbanos.com/terminos-y-condiciones-cliente/',
    3: 'https://mensajerosurbanos.com/terminos-y-condiciones-usuario/?lang=mx',
  },
  politicsLink: {
    1: 'https://mensajerosurbanos.com/politicas-de-privacidad-colombia/',
    3: 'https://mensajerosurbanos.com/politicas-de-privacidad-mexico/?lang=mx',
  },
  defaultPersonRole: 5,
  defaultCompanyRole: 6,
  passwordCheckerField: 'password',
  passwordCheckerName: 'passwordChecker',
  passwordCheckerParams: {
    length: 8,
    withSymbol: false,
    withLower: false,
    withUpper: true,
    withNumber: true,
  },
  seconds: 30,
  countryCode: {
    cop: 10,
    mx: 10,
  },
  dropdownCountries: {
    co: {
      id: 1,
      indivative: '57',
      icon: 'item-cop',
    },
    mx: {
      id: 3,
      indivative: '52',
      icon: 'item-mx',
    },
  },
  storagePhone: 'mu-auth-phone',
  codePhone: 'mu-code-phone',
  keyboardEvent: 'Backspace',
};
